<template>
    <div class="btn-bar">
        <btnRounded to="./yobomeshi" class="top yellow large font-large"
        v-if="pagename == 'open_lecture'">TOPに戻る</btnRounded>

        <btnRounded bg01 multi to="./yobomeshi/movie"
        class="b1-multiple-lines large font-middle"
        v-if="pagename == 'recipe' || pagename == 'about'">「予防めし」の作り方<br>YouTube動画集を見る</btnRounded>
        
        <btnRounded to="./yobomeshi" bg02 multi class="b1-multiple-lines large font-middle"
        v-if="pagename == 'movie'">「予防めし」Instagram<br>レシピ集を見る</btnRounded>

        <btnRounded to="./yobomeshi/about" class="b2 texture large font-middle"
        v-if="pagename == 'recipe' || pagename == 'movie' || pagename == 'open_lecture'">「予防めし」とは</btnRounded>

        <btnRounded to="./yobomeshi" bg02 multi class="b1-multiple-lines large font-middle"
        v-if="pagename == 'about'">「予防めし」Instagram<br>レシピ集を見る</btnRounded>
    </div>
</template>

<script>
import btnRounded from '@/components/parts/btn-rounded.vue'

export default {
    name: 'btn-bar',
    props:{
        pagename: String,
    },
    components:{
        btnRounded
    }
}
</script>

<style lang="scss" scoped>
    .btn-bar{
        max-width: calc(980px - 40px);
        padding: 260px 20px 200px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
        @media #{$maxM}{
            flex-flow: column;
            padding: 190px 20px;
        }
            .btn{
                max-width: calc(50% - 10px);
                @media #{$maxM}{
                    margin-bottom: 30px;
                }
                &.b1{
                    width: calc(50% - 7.95% - 9.38% - 10px);
                    padding-left: 7.95%;
                    padding-right: 9.38%;
                }
                @media #{$IE}{
                  &.b1{
                      width: calc(50% - 10px);
                      padding-left: 7.95%;
                      padding-right: 9.38%;
                  }
                }
                &.b1-multiple-lines{
                  width: calc(50% - 4.95% - 6.38% - 10px);
                  padding-left: 4.95%;
                  padding-right: 6.38%;
                }
                @media #{$IE}{
                  &.b1-multiple-lines{
                    width: calc(50% - 10px);
                    padding-left: 4.95%;
                    padding-right: 6.38%;
                  }
                }
                &.b2{
                    width: calc(50% - 13.3% - 17.04% - 10px);
                    padding-left: 13.3%;
                    padding-right: 17.04%;
                }
                @media #{$IE}{
                  &.b2{
                      width: calc(50% - 10px);
                      padding-left: 13.3%;
                      padding-right: 17.04%;
                  }
                }
                &.b3{
                    width: calc(50% - 10.2% - 11.63% - 10px);
                    padding-left: 10.2%;
                    padding-right: 11.63%;
                }
                @media #{$IE}{
                  &.b3{
                      width: calc(50% - 10px);
                      padding-left: 10.2%;
                      padding-right: 11.63%;
                  }
                }
                &.top{
                    width: calc(50% - 13.3% - 13.3% - 10px);
                    padding-left: 13.3%;
                    padding-right: 13.3%;
                    /deep/ .btn-inner span {
                      margin: 0 auto;
                    }
                }
                @media #{$IE}{
                  &.top{
                      width: calc(50% - 10px);
                      padding-left: 13.3%;
                      padding-right: 13.3%;
                  }
                }
            }

    }
</style>